var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioStarShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0L27.9375 16.2597L35.9498 1.97913L31.5174 17.7426L44.3848 7.61522L34.2574 20.4826L50.0209 16.0502L35.7403 24.0625L52 26L35.7403 27.9375L50.0209 35.9498L34.2574 31.5174L44.3848 44.3848L31.5174 34.2574L35.9498 50.0209L27.9375 35.7403L26 52L24.0625 35.7403L16.0502 50.0209L20.4826 34.2574L7.61522 44.3848L17.7426 31.5174L1.97913 35.9498L16.2597 27.9375L0 26L16.2597 24.0625L1.97913 16.0502L17.7426 20.4826L7.61522 7.61522L20.4826 17.7426L16.0502 1.97913L24.0625 16.2597L26 0Z",
    fill: "#C9A885"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioStarShape);
export default __webpack_public_path__ + "static/media/portfolio-star-shape.4751ac9c7647dd6471967f3b46d3d6ad.svg";
export { ForwardRef as ReactComponent };